import type { Template } from "@/types";

export const PO_07_H6_V1: Template[] = [
{
    id: "po-07-h6v1-01",
    name: "PO 01 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_01.png",
    size: [1217, 851],
    style: {},
        slots: [         
            { id: "1", x: 44, y: 237, width: 269, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 44, y: 430, width: 269, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 321, y: 237, width: 245, height: 378, rotation: 0, imageRotation: 0 },
            { id: "4", x: 652, y: 237, width: 258, height: 185, rotation: 0, imageRotation: 0 },
            { id: "5", x: 918, y: 237, width: 257, height: 185, rotation: 0, imageRotation: 0 },
            { id: "6", x: 652, y: 430, width: 258, height: 185, rotation: 0, imageRotation: 0 },
            { id: "7", x: 918, y: 430, width: 257, height: 185, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h6v1-02",
    name: "PO 02 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 47, y: 160, width: 514, height: 348, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 47, y: 516, width: 254, height: 174, rotation: 0, imageRotation: 0 },
        { id: "3", x: 309, y: 516, width: 253, height: 174, rotation: 0, imageRotation: 0 },
        { id: "4", x: 651, y: 160, width: 214, height: 172, rotation: 0, imageRotation: 0 },
        { id: "5", x: 651, y: 340, width: 214, height: 172, rotation: 0, imageRotation: 0 },
        { id: "6", x: 651, y: 520, width: 214, height: 171, rotation: 0, imageRotation: 0 },
        { id: "7", x: 873, y: 160, width: 296, height: 530, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-03",
    name: "PO 03 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 49, y: 182, width: 514, height: 353, rotation: 0, imageRotation: 0 },
        { id: "2", x: 49, y: 543, width: 167, height: 124, rotation: 0, imageRotation: 0 },
        { id: "3", x: 224, y: 543, width: 166, height: 124, rotation: 0, imageRotation: 0 },
        { id: "4", x: 398, y: 543, width: 166, height: 124, rotation: 0, imageRotation: 0 },
        { id: "5", x: 652, y: 130, width: 514, height: 342, rotation: 0, imageRotation: 0 },
        { id: "6", x: 652, y: 480, width: 346, height: 241, rotation: 0, imageRotation: 0 },
        { id: "7", x: 1006, y: 480, width: 161, height: 241, rotation: 0, imageRotation: 0 }       
    ],
},

{
    id: "po-07-h6v1-04",
    name: "PO 04 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [       
        { id: "1", x: 45, y: 124, width: 257, height: 197, rotation: 0, imageRotation: 0 },
        { id: "2", x: 45, y: 329, width: 257, height: 196, rotation: 0, imageRotation: 0 },
        { id: "3", x: 45, y: 533, width: 257, height: 196, rotation: 0, imageRotation: 0 },
        { id: "4", x: 310, y: 124, width: 256, height: 197, rotation: 0, imageRotation: 0 },
        { id: "5", x: 310, y: 329, width: 256, height: 196, rotation: 0, imageRotation: 0 },
        { id: "6", x: 310, y: 533, width: 256, height: 196, rotation: 0, imageRotation: 0 },
        { id: "7", x: 716, y: 124, width: 394, height: 605, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-05",
    name: "PO 05 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 57, y: 219, width: 270, height: 203, rotation: 0, imageRotation: 0 },
        { id: "2", x: 57, y: 430, width: 270, height: 203, rotation: 0, imageRotation: 0 },
        { id: "3", x: 335, y: 219, width: 270, height: 203, rotation: 0, imageRotation: 0 },
        { id: "4", x: 335, y: 430, width: 270, height: 203, rotation: 0, imageRotation: 0 },
        { id: "5", x: 613, y: 219, width: 270, height: 414, rotation: 0, imageRotation: 0 },
        { id: "6", x: 891, y: 219, width: 269, height: 203, rotation: 0, imageRotation: 0 },
        { id: "7", x: 891, y: 430, width: 269, height: 203, rotation: 0, imageRotation: 0 }      
    ],
},

{
    id: "po-07-h6v1-06",
    name: "PO 06 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [     
        { id: "1", x: 92, y: 111, width: 417, height: 311, rotation: 0, imageRotation: 0 },
        { id: "2", x: 92, y: 430, width: 417, height: 310, rotation: 0, imageRotation: 0 },
        { id: "3", x: 517, y: 111, width: 385, height: 629, rotation: 0, imageRotation: 0 },
        { id: "4", x: 910, y: 111, width: 215, height: 152, rotation: 0, imageRotation: 0 },
        { id: "5", x: 910, y: 271, width: 215, height: 151, rotation: 0, imageRotation: 0 },
        { id: "6", x: 910, y: 430, width: 215, height: 151, rotation: 0, imageRotation: 0 },
        { id: "7", x: 910, y: 589, width: 215, height: 151, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-07",
    name: "PO 07 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 43, y: 130, width: 264, height: 192, rotation: 0, imageRotation: 0 },
        { id: "2", x: 43, y: 330, width: 264, height: 192, rotation: 0, imageRotation: 0 },
        { id: "3", x: 43, y: 530, width: 264, height: 191, rotation: 0, imageRotation: 0 },
        { id: "4", x: 315, y: 130, width: 344, height: 591, rotation: 0, imageRotation: 0 },
        { id: "5", x: 667, y: 130, width: 504, height: 384, rotation: 0, imageRotation: 0 },      
        { id: "6", x: 667, y: 522, width: 249, height: 199, rotation: 0, imageRotation: 0 },
        { id: "7", x: 924, y: 522, width: 248, height: 199, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-08",
    name: "PO 08 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 66, y: 165, width: 328, height: 521, rotation: 0, imageRotation: 0 },
        { id: "2", x: 402, y: 165, width: 245, height: 169, rotation: 0, imageRotation: 0 },
        { id: "3", x: 402, y: 342, width: 245, height: 168, rotation: 0, imageRotation: 0 },
        { id: "4", x: 402, y: 518, width: 245, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 655, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 },
        { id: "6", x: 907, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 },
        { id: "7", x: 655, y: 165, width: 496, height: 345, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h6v1-09",
    name: "PO 09 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 66, y: 165, width: 328, height: 521, rotation: 0, imageRotation: 0 },
        { id: "2", x: 402, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 },     
        { id: "3", x: 402, y: 165, width: 496, height: 345, rotation: 0, imageRotation: 0 },
        { id: "4", x: 654, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 },
        { id: "5", x: 906, y: 165, width: 244, height: 169, rotation: 0, imageRotation: 0 },
        { id: "6", x: 906, y: 342, width: 244, height: 168, rotation: 0, imageRotation: 0 },
        { id: "7", x: 906, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 },
    ],
},

{
    id: "po-07-h6v1-10",
    name: "PO 10 - H6V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h6_v1_10.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 66, y: 165, width: 498, height: 344, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 66, y: 517, width: 245, height: 169, rotation: 0, imageRotation: 0 },
        { id: "3", x: 319, y: 517, width: 245, height: 169, rotation: 0, imageRotation: 0 },
        { id: "4", x: 572, y: 165, width: 328, height: 521, rotation: 0, imageRotation: 0 },
        { id: "5", x: 908, y: 165, width: 244, height: 169, rotation: 0, imageRotation: 0 },
        { id: "6", x: 908, y: 342, width: 244, height: 168, rotation: 0, imageRotation: 0 },
        { id: "7", x: 908, y: 518, width: 244, height: 168, rotation: 0, imageRotation: 0 }
    ],
}
];